"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { getNotificationNavigationTarget } from "@/lib/notification-links";

function isPushWorkerSupported(): boolean {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    window.isSecureContext
  );
}

export function NotificationServiceWorkerBridge() {
  const router = useRouter();

  useEffect(() => {
    if (!isPushWorkerSupported()) return;

    let active = true;

    navigator.serviceWorker
      .register("/sw-notifications.js", { updateViaCache: "none" })
      .then((registration) => registration.update())
      .catch(() => {
        // Push setup is best-effort here. The preferences page reports errors.
      });

    const handleMessage = (event: MessageEvent) => {
      if (!active || !event.data || event.data.type !== "notification-click") return;
      const link = typeof event.data.link === "string" ? event.data.link : "";
      if (!link) return;

      const target = getNotificationNavigationTarget(link);
      if (!target) return;
      if (/^https?:\/\//.test(target)) {
        window.location.assign(target);
        return;
      }

      router.push(target);
    };

    navigator.serviceWorker.addEventListener("message", handleMessage);
    return () => {
      active = false;
      navigator.serviceWorker.removeEventListener("message", handleMessage);
    };
  }, [router]);

  return null;
}
